(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SunWeb", [], factory);
	else if(typeof exports === 'object')
		exports["SunWeb"] = factory();
	else
		root["SunWeb"] = factory();
})(window, function() {
return 